import { openModal } from '@core/components/ModalStack';
import { NewEmailModalProps } from './NewEmailModal';

export async function openNewEmailModal(props: NewEmailModalProps) {
  const { NewEmailModal } = await import('./NewEmailModal');

  openModal(NewEmailModal, props);
}
